// extracted by mini-css-extract-plugin
module.exports = {"title":"WelcomeMessage_title__2qnsJ","titleLink":"WelcomeMessage_titleLink__wCpdr"};